"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_dnd_1 = require("react-dnd");
const react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
const styled_components_1 = __importDefault(require("styled-components"));
const Button_1 = __importStar(require("@app/routes/SpeechDevelopment/components/Button"));
const useCoins_1 = __importDefault(require("@hooks/useCoins"));
const audioPlayer_1 = require("@app/services/audioPlayer");
const menuBarExercise_1 = __importDefault(require("@components/menuBar/menuBarExercise"));
const ExerciseControls_1 = require("@app/routes/SpeechDevelopment/components/ExerciseControls");
const Pagination_1 = require("@components/Pagination");
const exercise_1 = require("@components/container/exercise");
const quantityGame_1 = __importDefault(require("@components/quantity/quantityGame"));
const translations_1 = require("@app/routes/SpeechDevelopment/translations");
const sendInfoReport_1 = require("@app/utils/sendInfoReport");
const useBeforeUnloadReport_1 = require("@hooks/useBeforeUnloadReport");
const helpers_1 = require("@app/helpers");
const synonymAdapter_1 = require("../Synonym/synonymAdapter");
const ResponsiveStyles_1 = require("@components/typography/ResponsiveStyles");
// Generates initial state for the check buttons
const generateInitialState = (length) => {
    return Array.from({ length }, (_, index) => ({
        isCorrect: false,
        index: index + 1,
        isChecked: false
    }));
};
const DropContainerWrapper = styled_components_1.default.div `
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    gap: 10px;
    align-items: self-start;
    justify-content: end;
    height: 100%;
    @media (max-width: 1200px) {
        justify-content: center;
    }
    @media (max-width: 700px) {
        flex-wrap: wrap-reverse;
    }
`;
// Renamed styled component to avoid conflict with interface
const StyledWordItem = styled_components_1.default.div `
    margin: 12px;
    background: transparent;
    padding: 5px 20px;
    border: 1px dashed #6E76FB;
    border-radius: 25px;
    cursor: pointer;
    user-select: none;
    font-size: 40px;
    font-weight: 700;
    color: #6E76FB;
    line-height: 40px;
    font-family: Phenomena;
    transition: background-color 0.2s ease-in-out;

    ${(props) => props.isCorrect !== undefined && `
      border: ${props.isCorrect ? '1px dashed #3CB949' : '1px dashed #FE2B45'};
      color: ${props.isCorrect ? '#3CB949' : '#FE2B45'};
  `}
    &:hover {
        background-color: #dcdcdc;
    }
    ${ResponsiveStyles_1.responsiveWordItemStyles}
`;
const StyledWordItem3D = styled_components_1.default.div `
  padding: 14px 24px;
  border: 4px dashed #6E76FB;
  border-radius: 25px;
  user-select: none;

  /* 3D ШРИФТ */
  font-size: 28px;
  font-weight: 100;
  font-family: 'Arial', sans-serif;
  line-height: 1;
  letter-spacing: 0.1em;
  color: #505050;
  text-shadow: 1px 2px 2px rgb(0, 0, 0), 3px 2px 2px rgba(52, 52, 52, 0.83);

  /* Курсор в зависимости от состояния */
  cursor: ${props => props.isCorrect ? 'not-allowed' : (props.isDragging ? 'grabbing' : 'grab')} !important;

  /* Анимация при перетаскивании */
  transform: ${props => props.isDragging ? 'scale(0.95)' : 'scale(1)'};
  transition: all 0.2s ease;

  /* Правильный/неправильный */
  ${(props) => props.isCorrect !== undefined && `
    border: ${props.isCorrect ? '1px dashed #3CB949' : '1px dashed #FE2B45'};
    color: ${props.isCorrect ? '#3CB949' : '#FE2B45'};
  `}
  ${(props) => props.isCorrect && `
    --correct-green: #3CB949;
    color: var(--correct-green) !important;
    text-shadow: 1px 2px 2px #2E8B2E, 1px 2px 2px rgba(34, 139, 34, 0.6);
  `}
  ${(props) => props.isCorrect === false && `
    --error-red: #FE2B45;
    color: var(--error-red) !important;
    text-shadow: 1px 2px 2px #CC0000, 1px 2px 2px rgba(153, 0, 0, 0.6);
  `}
    
  /* кликнутый/некликнутый */
  ${(p) => p.isSelected && `
      border:4px solid #FFD54A;
      animation: pulse 0.8s infinite;
  `}
  @keyframes pulse {
    0% { box-shadow:0 0 0 0 rgba(255,213,74,.8);}
    100% { box-shadow:0 0 0 12px rgba(255,213,74,0);}
  }

  &:hover:not([data-is-correct="true"]) {
    transform: translateY(-2px);
    cursor: grab;
  }
  &:active:not([data-is-correct="true"]) {
    cursor: grabbing;
    transform: translateY(0px);
  }

  @media (max-width: 870px) {
    font-size: 25px;
    text-shadow: 1px 2px 2px rgba(0, 0, 0, 0.4), 1px 2px 2px rgba(52, 52, 52, 0.83);
    padding: 4px 8px;
  }
  @media (max-width: 540px) {
    font-size: 20px;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4), 1px 1px 1px rgba(52, 52, 52, 0.83);
    padding: 3px 6px;
  }
`;
const GroupContainer = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
    padding: 10px 8px;
    flex-wrap: wrap;
    gap: 10px;
    width: auto;
    min-height: 50px;
    background-color: #f9f9f9;
    border-radius: 8px;
`;
const GroupContainerHorizontal = styled_components_1.default.div `
  display: flex;
  margin: 16px;
  padding: 8px;
  flex-wrap: wrap;
  width: auto;
  background-color: #f9f9f9;
  border-radius: 8px;
`;
const ImageBox = styled_components_1.default.div `
    display: flex;
    justify-content: end;
    align-items: end;
    max-width: 100%;
`;
const Image = styled_components_1.default.img `
    width: 100%;
    height: auto;
    max-width: 350px;
`;
const Box = styled_components_1.default.div `
    display: flex;
    border-radius: 12px;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    width: 80%;
    overflow: hidden;
    @media (max-width: 768px) {
        width: 90%;
        max-width: 400px;
    }
    @media (max-width: 700px) {
        flex-direction: column;
    }
    @media (max-height: 600px) {
        padding: 10px;
        max-height: 50%;
    }
`;
let infoRep = [];
let checkedAnswer = [];
// Word component with updated drag and drop hover logic
const Word = ({ word, index, moveWord, groupIndex }) => {
    const ref = (0, react_1.useRef)(null);
    const [{ isDragging }, drag] = (0, react_dnd_1.useDrag)({
        type: 'WORD',
        item: {
            index,
            groupIndex,
            id: `${groupIndex}-${index}-${word.word}` // Уникальный идентификатор
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });
    const [, drop] = (0, react_dnd_1.useDrop)({
        accept: 'WORD',
        hover(draggedItem, monitor) {
            if (!ref.current)
                return;
            // Не перетаскиваем на себя
            if (draggedItem.groupIndex === groupIndex && draggedItem.index === index)
                return;
            const boundingRect = ref.current.getBoundingClientRect();
            const hoverMiddleY = (boundingRect.bottom - boundingRect.top) / 2;
            const clientOffset = monitor.getClientOffset();
            if (!clientOffset)
                return;
            const hoverClientY = clientOffset.y - boundingRect.top;
            // Если перетаскиваем из другой группы
            if (draggedItem.groupIndex !== groupIndex) {
                moveWord(draggedItem.index, index, draggedItem.groupIndex, groupIndex);
                draggedItem.index = index;
                draggedItem.groupIndex = groupIndex;
                return;
            }
            // Перетаскивание внутри одной группы
            if (draggedItem.index < index && hoverClientY < hoverMiddleY) {
                return;
            }
            if (draggedItem.index > index && hoverClientY > hoverMiddleY) {
                return;
            }
            moveWord(draggedItem.index, index, groupIndex, groupIndex);
            draggedItem.index = index;
        }
    });
    drag(drop(ref));
    return (react_1.default.createElement(StyledWordItem, { ref: ref, isCorrect: word === null || word === void 0 ? void 0 : word.isCorrect, style: { opacity: isDragging ? 0.5 : 1 } }, word.word));
};
const Group = ({ group, words, moveWord, response }) => {
    var _a;
    const groupIndex = group - 1;
    if (((_a = response === null || response === void 0 ? void 0 : response.text) === null || _a === void 0 ? void 0 : _a.text_type) === 'text_picture_pair') {
        return (react_1.default.createElement(GroupContainer, null, words.map((word, index) => (react_1.default.createElement(Word, { key: `${groupIndex}-${index}-${word.word}`, word: word, index: index, groupIndex: groupIndex, moveWord: moveWord })))));
    }
    return (react_1.default.createElement(GroupContainerHorizontal, null, words.map((word, index) => (react_1.default.createElement(Word, { key: `${groupIndex}-${index}-${word.word}`, word: word, index: index, groupIndex: groupIndex, moveWord: moveWord })))));
};
const groupAndSortItems = (items) => {
    const grouped = items.reduce((acc, item) => {
        if (!acc[item.group])
            acc[item.group] = [];
        acc[item.group].push(item);
        return acc;
    }, {});
    return Object.keys(grouped).map(key => grouped[Number(key)]);
};
const SentenceWordOrder = ({ response, description, langId }) => {
    var _a, _b;
    const [words, setWords] = (0, react_1.useState)([]);
    const [dropZones, setDropZones] = (0, react_1.useState)([]);
    const [intialWords, setIntialWords] = (0, react_1.useState)([]);
    const [currentWord, setCurrentWord] = (0, react_1.useState)([]);
    const [currentIndex, setCurrentIndex] = (0, react_1.useState)(0);
    const [wrongAnswerCount, setWrongAnswerCount] = (0, react_1.useState)(0);
    const [images, setImages] = (0, react_1.useState)(null);
    const { coinCount, rubyCount, diamondCount, addCoin } = (0, useCoins_1.default)();
    const [checkButtons, setCheckButtons] = (0, react_1.useState)(generateInitialState(10));
    const [availableWords, setAvailableWords] = (0, react_1.useState)([]); // слова слева
    const [isStarted, setIsStarted] = (0, react_1.useState)(false);
    const [isPaused, setIsPaused] = (0, react_1.useState)(true);
    const isTransitioningRef = (0, react_1.useRef)(false);
    const [selectedWord, setSelectedWord] = (0, react_1.useState)(null);
    const [wrongTries, setWrongTries] = (0, react_1.useState)(0);
    const [feedback, setFeedback] = (0, react_1.useState)('');
    const handleStart = () => {
        setIsStarted(true);
        setIsPaused(false);
    };
    const handlePause = () => setIsPaused(true);
    const handleNext = () => {
        setCheckButtons(prev => {
            const indexToUpdate = prev.findIndex(btn => !btn.isChecked);
            if (indexToUpdate !== -1) {
                const updated = prev.map((btn, i) => i === indexToUpdate ? Object.assign(Object.assign({}, btn), { isChecked: true, isCorrect: false }) : btn);
                checkedAnswer = updated;
                return updated;
            }
            return prev;
        });
        setCurrentIndex(prev => {
            const newIndex = Math.min(prev + 1, words.length - 1);
            const nextGroup = words[newIndex];
            const shuffledWords = (0, helpers_1.shuffleArray)(nextGroup.map((item) => ({
                word: item.right_word || item.word,
                order: item.order,
                group: item.group,
                hint: item.hint,
                is_correct: null
            })));
            setAvailableWords(shuffledWords);
            setImages(nextGroup);
            setDropZones(Array.from({ length: nextGroup.length }, () => []));
            return newIndex;
        });
    };
    const handlePrev = () => {
        setCheckButtons(prev => {
            const indexToUpdate = prev.findIndex(btn => !btn.isChecked);
            if (indexToUpdate !== -1) {
                const updated = prev.map((btn, i) => i === indexToUpdate ? Object.assign(Object.assign({}, btn), { isChecked: true, isCorrect: false }) : btn);
                checkedAnswer = updated;
                return updated;
            }
            return prev;
        });
        setCurrentIndex(prev => {
            const newIndex = Math.max(0, prev - 1);
            const prevGroup = words[newIndex];
            const shuffledWords = (0, helpers_1.shuffleArray)(prevGroup.map((item) => ({
                word: item.right_word || item.word,
                order: item.order,
                group: item.group,
                hint: item.hint,
                is_correct: null
            })));
            setAvailableWords(shuffledWords);
            setImages(prevGroup);
            setDropZones(Array.from({ length: prevGroup.length }, () => []));
            return newIndex;
        });
    };
    const playDropSound = (isCorrect) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const key = (0, audioPlayer_1.getPreloadSoundKey)(langId, isCorrect ? "correct" : 318);
            const promise = audioPlayer_1.audioPlayer.playAudio(key);
            if (promise) {
                promise.catch((error) => {
                    if (error.name !== 'AbortError')
                        console.error('Audio error:', error);
                });
            }
        }
        catch (error) {
            // игнорируем все ошибки
        }
    });
    (0, useBeforeUnloadReport_1.useBeforeUnloadReport)(() => ({ infoRep, exerciseId: (response === null || response === void 0 ? void 0 : response.number) || (response === null || response === void 0 ? void 0 : response.id), checkedAnswer }));
    const handleAddCoin = () => addCoin(3, 5);
    (0, react_1.useEffect)(() => {
        var _a;
        if (response) {
            if (response.text.text_type === 'text_picture_pair') {
                const groups = (0, synonymAdapter_1.getTextPicturePairs)(response);
                setCurrentIndex(0);
                const currentGroup = ((_a = groups[0]) === null || _a === void 0 ? void 0 : _a.items) || [];
                const shuffledWords = (0, helpers_1.shuffleArray)(currentGroup.map((item) => ({
                    word: item.right_word || item.word,
                    order: item.order,
                    group: item.group || 1,
                    hint: item.hint,
                    is_correct: null
                })));
                setAvailableWords(shuffledWords);
                setImages(currentGroup);
                setDropZones(Array(currentGroup.length).fill([]));
                setWords(groups.map(g => g.items));
                setCheckButtons(generateInitialState(groups.length));
                checkedAnswer = generateInitialState(groups.length);
            }
            else {
                const processedData = groupAndSortItems((response === null || response === void 0 ? void 0 : response.form) || []);
                setWords(processedData);
                setCurrentIndex(0);
                setIntialWords(processedData);
                setCurrentWord([processedData[0]]);
                setImages((response === null || response === void 0 ? void 0 : response.images) || []);
                setCheckButtons(generateInitialState(processedData.length));
                setDropZones([[]]);
                checkedAnswer = generateInitialState(processedData.length);
            }
            infoRep = [{ rep_id: 1, category_name: '', system_time: '', startTime: Date.now() }];
        }
    }, [response]);
    const moveWordToZone = (0, react_1.useCallback)((draggedWord, targetZoneIndex) => {
        var _a;
        if (((_a = response === null || response === void 0 ? void 0 : response.text) === null || _a === void 0 ? void 0 : _a.text_type) !== 'text_picture_pair')
            return;
        setDropZones(prevZones => {
            const newZones = prevZones.map(zone => [...zone]);
            newZones.forEach(zone => {
                const idx = zone.findIndex(w => w.word === draggedWord.word);
                if (idx > -1)
                    zone.splice(idx, 1);
            });
            const targetImageOrder = targetZoneIndex + 1;
            const isCorrect = draggedWord.order === targetImageOrder;
            const updatedWord = Object.assign(Object.assign({}, draggedWord), { isCorrect });
            newZones[targetZoneIndex].push(updatedWord);
            setAvailableWords(prev => prev.filter(w => w.word !== draggedWord.word));
            // если ещё не все заполнены — просто локальный звук и выходим
            const allFilled = newZones.every(zone => zone.length === 1);
            if (!allFilled) {
                playDropSound(isCorrect);
                return newZones;
            }
            // если все заполнены — проверка/переход через общий helper
            return handleAllCorrect(newZones);
        });
    }, [response, langId, currentIndex, words]);
    const checkAllPairs = () => {
        var _a;
        if (((_a = response === null || response === void 0 ? void 0 : response.text) === null || _a === void 0 ? void 0 : _a.text_type) !== 'text_picture_pair')
            return false;
        let correctCount = 0;
        const updatedZones = dropZones.map((zone, zoneIndex) => {
            if (zone.length !== 1)
                return zone;
            const word = zone[0];
            const isCorrect = word.order === zoneIndex + 1;
            if (isCorrect)
                correctCount++;
            return zone.map(w => (Object.assign(Object.assign({}, w), { isCorrect })));
        });
        setDropZones(updatedZones);
        const allCorrect = correctCount === images.length &&
            updatedZones.every(z => z.length === 1);
        if (allCorrect) {
            handleAddCoin();
            // звук correct
            audioPlayer_1.audioPlayer.playAudio((0, audioPlayer_1.getPreloadSoundKey)(langId, "correct"));
            const nextIndex = currentIndex + 1;
            // переключение на следующую группу
            setTimeout(() => {
                if (nextIndex < words.length) {
                    const nextGroup = words[nextIndex];
                    const shuffledWords = (0, helpers_1.shuffleArray)(nextGroup.map((item) => ({
                        word: item.right_word || item.word,
                        order: item.order,
                        group: item.group,
                        hint: item.hint,
                        is_correct: null
                    })));
                    setCurrentIndex(nextIndex);
                    setAvailableWords(shuffledWords);
                    setImages(nextGroup);
                    setDropZones(Array.from({ length: nextGroup.length }, () => []));
                    isTransitioningRef.current = false;
                }
                else {
                    (0, sendInfoReport_1.sendInfoReport)(infoRep, (response === null || response === void 0 ? void 0 : response.number) || (response === null || response === void 0 ? void 0 : response.id), window.userId, checkedAnswer);
                    window.stopExercise(true, true, response.id);
                }
            }, 2000); // задержка чтобы услышать correct
        }
        else {
            audioPlayer_1.audioPlayer.playAudio((0, audioPlayer_1.getPreloadSoundKey)(langId, 318));
        }
        return allCorrect;
    };
    const checkSentence = () => {
        const checkCorrectSubArray = (subArray) => {
            const groupMap = new Map();
            subArray.forEach((word) => {
                if (!groupMap.has(word.group)) {
                    groupMap.set(word.group, []);
                }
                groupMap.get(word.group).push(word);
            });
            if (groupMap.size === 1) {
                // Validate correct order
                return subArray.map((word, index) => (Object.assign(Object.assign({}, word), { isCorrect: (word === null || word === void 0 ? void 0 : word.order) === index + 1 })));
            }
            else {
                return subArray.map((word) => (Object.assign(Object.assign({}, word), { isCorrect: false })));
            }
        };
        const updatedGroup = checkCorrectSubArray(words[currentIndex]);
        const updatedWords = words.map((group, index) => index === currentIndex ? updatedGroup : group);
        setWords(updatedWords);
        setCurrentWord([updatedGroup]);
        const isAllCorrect = updatedGroup.every((word) => word.isCorrect);
        if (isAllCorrect) {
            handleAddCoin();
            audioPlayer_1.audioPlayer.playAudio((0, audioPlayer_1.getPreloadSoundKey)(langId, "correct"));
            const nextIndex = Math.min(currentIndex + 1, words.length - 1);
            setTimeout(() => {
                setCurrentIndex(nextIndex);
                setCurrentWord([updatedWords[nextIndex]]);
                setWrongAnswerCount(0);
            }, 7000);
        }
        else if (wrongAnswerCount >= 2) {
            const nextIndex = Math.min(currentIndex + 1, words.length - 1);
            setCurrentIndex(nextIndex);
            setCurrentWord([updatedWords[nextIndex]]);
            setWrongAnswerCount(0);
        }
        else {
            audioPlayer_1.audioPlayer.playAudio((0, audioPlayer_1.getPreloadSoundKey)(langId, 318));
            setWrongAnswerCount((prev) => prev + 1);
        }
        return isAllCorrect;
    };
    const handleCheckButtonClick = () => {
        var _a;
        let isChecked = false;
        if (((_a = response === null || response === void 0 ? void 0 : response.text) === null || _a === void 0 ? void 0 : _a.text_type) === 'text_picture_pair') {
            if (!isStarted || isPaused)
                return;
            isChecked = checkAllPairs();
        }
        else {
            isChecked = checkSentence();
        }
        infoRep = (0, sendInfoReport_1.trackAttemptTime)(infoRep, isChecked);
        setCheckButtons((prevButtons) => {
            const indexToUpdate = prevButtons.findIndex(button => !button.isChecked);
            if (indexToUpdate === -1) {
                // @ts-ignore
                window.stopExercise(true, true, response === null || response === void 0 ? void 0 : response.id);
                // @ts-ignore
                (0, sendInfoReport_1.sendInfoReport)(infoRep, (response === null || response === void 0 ? void 0 : response.number) || (response === null || response === void 0 ? void 0 : response.id), window.userId, checkedAnswer);
                return prevButtons;
            }
            const updatedButtons = prevButtons.map((button, index) => {
                if (index === indexToUpdate) {
                    if (indexToUpdate === (checkButtons === null || checkButtons === void 0 ? void 0 : checkButtons.length) - 1) {
                        if (wrongAnswerCount === 2 || isChecked) {
                            // @ts-ignore
                            window.stopExercise(true, true, response === null || response === void 0 ? void 0 : response.id);
                            // @ts-ignore
                            (0, sendInfoReport_1.sendInfoReport)(infoRep, (response === null || response === void 0 ? void 0 : response.number) || (response === null || response === void 0 ? void 0 : response.id), window.userId, checkedAnswer);
                        }
                    }
                    return Object.assign(Object.assign({}, button), { isChecked: isChecked || (!isChecked && wrongAnswerCount === 2), isCorrect: (wrongAnswerCount === 2 || isChecked) ? isChecked : undefined });
                }
                return button;
            });
            checkedAnswer = updatedButtons;
            // Add new infoRep entry for next attempt
            if (isChecked || wrongAnswerCount === 2) {
                infoRep = [...infoRep, { rep_id: infoRep.length + 1, category_name: '', system_time: '', startTime: Date.now() }];
            }
            return updatedButtons;
        });
    };
    const moveWord = (fromIndex, toIndex) => {
        const updatedGroup = [...words[currentIndex]];
        const [movedWord] = updatedGroup.splice(fromIndex, 1);
        updatedGroup.splice(toIndex, 0, movedWord);
        setWords(words.map((group, index) => (index === currentIndex ? updatedGroup : group)));
        setCurrentWord([updatedGroup]);
    };
    const handleAllCorrect = (zones) => {
        const allFilled = zones.every(zone => zone.length === 1);
        if (!allFilled)
            return zones;
        const allCorrect = zones.every((zone, i) => zone[0].order === i + 1);
        if (!allCorrect)
            return zones;
        const markedZones = zones.map(zone => [Object.assign(Object.assign({}, zone[0]), { isCorrect: true })]);
        playDropSound(true);
        // audioPlayer.playAudio(getPreloadSoundKey(langId, 'correct'));
        handleAddCoin();
        setCheckButtons(prev => {
            const updated = [...prev];
            updated[currentIndex] = Object.assign(Object.assign({}, updated[currentIndex]), { isChecked: true, isCorrect: true });
            checkedAnswer = updated;
            return updated;
        });
        const nextIndex = currentIndex + 1;
        setTimeout(() => {
            if (nextIndex < words.length) {
                const nextGroup = words[nextIndex];
                const shuffledWords = (0, helpers_1.shuffleArray)(nextGroup.map((item) => ({
                    word: item.right_word || item.word,
                    order: item.order,
                    group: item.group,
                    hint: item.hint,
                    is_correct: null,
                })));
                setCurrentIndex(nextIndex);
                setAvailableWords(shuffledWords);
                setImages(nextGroup);
                setDropZones(Array.from({ length: nextGroup.length }, () => []));
            }
            else {
                (0, sendInfoReport_1.sendInfoReport)(infoRep, (response === null || response === void 0 ? void 0 : response.number) || (response === null || response === void 0 ? void 0 : response.id), window.userId, checkedAnswer);
                window.stopExercise(true, true, response.id);
            }
        }, 2000);
        return markedZones;
    };
    const handleClickAnswer = (zoneIndex) => {
        if (!selectedWord)
            return;
        const isCorrect = selectedWord.order === zoneIndex + 1;
        if (isCorrect) {
            moveWordToZone(selectedWord, zoneIndex);
            setSelectedWord(null);
            setWrongTries(0);
            setFeedback('');
            return;
        }
        playDropSound(false);
        setWrongTries(prev => {
            const next = prev + 1;
            if (next >= 3) {
                setFeedback('');
                setAvailableWords(prevWords => prevWords.map(w => w.order === zoneIndex + 1
                    ? Object.assign(Object.assign({}, w), { isCorrect: true }) : w));
                setCheckButtons(prev => {
                    const updated = [...prev];
                    updated[currentIndex] = Object.assign(Object.assign({}, updated[currentIndex]), { isChecked: true, isCorrect: false });
                    return updated;
                });
                setTimeout(() => handleNext(), 1500);
                return 0;
            }
            setFeedback('Попробуй ещё раз');
            return next;
        });
        setSelectedWord(Object.assign(Object.assign({}, selectedWord), { isCorrect: false }));
    };
    if (((_a = response === null || response === void 0 ? void 0 : response.text) === null || _a === void 0 ? void 0 : _a.text_type) === 'text_picture_pair') {
        const DraggableWord = ({ word, isInZone = false, zoneIndex = null, onSelect, selectedWord, }) => {
            const [{ isDragging }, drag] = (0, react_dnd_1.useDrag)({
                type: 'WORD_PAIR',
                item: { word: Object.assign({}, word), sourceZone: zoneIndex, isFromZone: isInZone },
                canDrag: !word.isCorrect,
                collect: (monitor) => ({ isDragging: monitor.isDragging() }),
            });
            return (react_1.default.createElement(StyledWordItem3D, { ref: drag, isCorrect: word.isCorrect, isDragging: isDragging, isSelected: (selectedWord === null || selectedWord === void 0 ? void 0 : selectedWord.word) === word.word, style: { opacity: isDragging ? 0.5 : 1 }, onClick: () => {
                    if (!isInZone && !word.isCorrect && onSelect) {
                        onSelect(word);
                    }
                } }, word.word.toUpperCase()));
        };
        // Компонент для зоны с картинкой (drop target)
        const DropZone = ({ imgData, index, dropZones, moveWordToZone, selectedWord, onWordPlace, }) => {
            const ref = (0, react_1.useRef)(null);
            const [isOver, setIsOver] = (0, react_1.useState)(false);
            const [{ isOver: isOverDnD }, drop] = (0, react_dnd_1.useDrop)({
                accept: 'WORD_PAIR',
                hover: () => setIsOver(true),
                drop: (item) => {
                    setIsOver(false);
                    if (item.word.isCorrect)
                        return;
                    const targetZone = dropZones[index] || [];
                    const sourceZoneIndex = item.sourceZone;
                    // СВАП ЛОГИКА
                    if (targetZone.length > 0 && !targetZone[0].isCorrect) {
                        const targetWord = Object.assign({}, targetZone[0]);
                        setDropZones(prevZones => {
                            const newZones = prevZones.map(z => [...z]);
                            if (item.isFromZone && sourceZoneIndex !== null) {
                                newZones[sourceZoneIndex] = [Object.assign(Object.assign({}, targetWord), { isCorrect: targetWord.order === (sourceZoneIndex + 1) })];
                                newZones[index] = [Object.assign(Object.assign({}, item.word), { isCorrect: item.word.order === (index + 1) })];
                            }
                            else {
                                setAvailableWords(prev => [
                                    ...prev,
                                    Object.assign(Object.assign({}, targetWord), { isCorrect: undefined }),
                                ]);
                                newZones[index] = [Object.assign(Object.assign({}, item.word), { isCorrect: item.word.order === (index + 1) })];
                            }
                            const allFilled = newZones.every(zone => zone.length === 1);
                            if (!allFilled) {
                                // только локальный звук по результату текущего дропа
                                const isCorrectNow = newZones[index][0].order === index + 1;
                                playDropSound(isCorrectNow);
                                return newZones;
                            }
                            // все заполнены — дальше решает handleAllCorrect
                            return handleAllCorrect(newZones);
                        });
                        return;
                    }
                    if (item.isFromZone && sourceZoneIndex !== null) {
                        moveWordToZone(item.word, index, true);
                    }
                    else {
                        moveWordToZone(item.word, index, false);
                    }
                },
                collect: (monitor) => ({
                    isOver: monitor.isOver(),
                }),
            });
            drop(ref);
            return (react_1.default.createElement("div", { ref: ref, onClick: () => {
                    if (selectedWord) {
                        onWordPlace(index);
                    }
                }, style: {
                    width: `min(400px, 50vw)`,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    border: `2px ${isOverDnD ? 'solid #00BFFF' : 'dashed #6E76FB'}`,
                    borderRadius: '12px',
                    padding: '15px 10px 0 10px',
                    background: '#f9f9f9',
                    transition: 'all 0.2s ease',
                    opacity: isOver ? 0.8 : 1,
                } },
                react_1.default.createElement("img", { src: imgData.hint, alt: "", style: { width: '300px', height: '200px', marginBottom: '10px', objectFit: 'contain' } }),
                react_1.default.createElement("div", { style: { minHeight: '50px' } }, (dropZones[index] || []).map((word, i) => (react_1.default.createElement(DraggableWord, { key: `${word.word}-${i}`, word: word, isInZone: true, zoneIndex: index }))))));
        };
        return (react_1.default.createElement(react_dnd_1.DndProvider, { backend: react_dnd_html5_backend_1.HTML5Backend },
            react_1.default.createElement(exercise_1.ContainerExercise, null,
                react_1.default.createElement(exercise_1.ExerciseWrapper, null,
                    react_1.default.createElement(DropContainerWrapper, { style: { gap: '20px' } },
                        react_1.default.createElement("div", { style: { flex: 1 } },
                            react_1.default.createElement(GroupContainer, null, (availableWords || []).map((word, index) => (react_1.default.createElement(DraggableWord, { key: word.word, word: word, onSelect: setSelectedWord, selectedWord: selectedWord, isInZone: false }))))),
                        react_1.default.createElement("div", { style: { flex: 2, display: 'flex', flexWrap: 'wrap', gap: '15px' } }, (images || []).map((imgData, index) => (react_1.default.createElement(DropZone, { key: index, imgData: imgData, index: index, dropZones: dropZones, moveWordToZone: moveWordToZone, selectedWord: selectedWord, onWordPlace: handleClickAnswer })))),
                        react_1.default.createElement(quantityGame_1.default, { diamondCount: diamondCount, rubyCount: rubyCount, goldCoin: coinCount })),
                    react_1.default.createElement(Pagination_1.Pagination, null, checkButtons.map((item, i) => react_1.default.createElement(Pagination_1.PaginationItem, { key: i, item: item })))),
                react_1.default.createElement(ExerciseControls_1.ExerciseControls, { currentCardIndex: currentIndex, isPaused: isPaused, isStarted: isStarted, canLeaf: true, isLast: currentIndex === words.length - 1, handleStart: handleStart, handlePause: handlePause, handleNext: handleNext, handlePrev: handlePrev, handleEndExercise: () => {
                        setIsStarted(false);
                        window.stopExercise(true, true, response === null || response === void 0 ? void 0 : response.id);
                        (0, sendInfoReport_1.sendInfoReport)(infoRep, (response === null || response === void 0 ? void 0 : response.number) || (response === null || response === void 0 ? void 0 : response.id), window.userId, checkedAnswer);
                    } }))));
    }
    return (react_1.default.createElement(react_dnd_1.DndProvider, { backend: react_dnd_html5_backend_1.HTML5Backend },
        react_1.default.createElement(exercise_1.ContainerExercise, null,
            react_1.default.createElement(exercise_1.ExerciseWrapper, null,
                react_1.default.createElement(DropContainerWrapper, null,
                    react_1.default.createElement(Box, null,
                        react_1.default.createElement(Group, { group: currentIndex + 1, words: currentWord[0] || [], moveWord: moveWord, response: response }),
                        react_1.default.createElement(ImageBox, null,
                            react_1.default.createElement(Image, { src: `${(_b = images === null || images === void 0 ? void 0 : images[currentIndex]) === null || _b === void 0 ? void 0 : _b.hint}`, alt: `Image ${currentIndex + 1}` }))),
                    react_1.default.createElement(quantityGame_1.default, { diamondCount: diamondCount, rubyCount: rubyCount, goldCoin: coinCount })),
                react_1.default.createElement(Pagination_1.Pagination, null, checkButtons.map((item, index) => (react_1.default.createElement(Pagination_1.PaginationItem, { key: index, item: item, active: item.isCorrect && item.isChecked
                        ? "linear-gradient(130deg, #6cff4f 13.21%, #13c21c 81.73%)"
                        : !item.isCorrect && item.isChecked
                            ? "#FF1431"
                            : null }))))),
            react_1.default.createElement(menuBarExercise_1.default, null,
                react_1.default.createElement(Button_1.ButtonContainerWrapper, null,
                    react_1.default.createElement(Button_1.default, { isShowShadow: false, label: (0, translations_1.getLabelCheckButton)(langId), onClick: handleCheckButtonClick, isCheckButton: true }))))));
};
exports.default = SentenceWordOrder;
